import {
  header_button_default
} from "./chunk-QMLW6FHI.mjs";
import {
  HelpCenterSidePanel
} from "./chunk-WLDRGDKP.mjs";
import {
  useEvents
} from "./chunk-TFRVQL75.mjs";
import {
  HelpCenterEvents
} from "./chunk-AOTFDLGI.mjs";
import {
  useLayoutContext
} from "./chunk-HFINPXUM.mjs";

// src/internal/components/help-center-panel/help-center-header-button.tsx
import { useAnalytics } from "@clara/events";
import { HelpHeadsetIcon } from "@clara/icons";
import { useLocaleContext, useT } from "@clara/locale";
import { ZendeskButton } from "@clara/zendesk";
import { jsx } from "react/jsx-runtime";
var HelpCenterHeaderButton = () => {
  const { sidePanel } = useLayoutContext();
  const { locale } = useLocaleContext();
  const analytics = useAnalytics();
  const { eventData } = useEvents();
  const { t } = useT("common");
  const country = locale.preferences.id;
  switch (country) {
    case "CO":
    case "MX":
      return /* @__PURE__ */ jsx(
        header_button_default,
        {
          "data-testid": "header-help",
          leftIcon: /* @__PURE__ */ jsx(HelpHeadsetIcon, {}),
          onClick: () => {
            analytics.track(HelpCenterEvents.EXPERIENCE_HELPERSIDE_OPEN, {
              ...eventData,
              action: "open"
            });
            sidePanel.onOpen(HelpCenterSidePanel);
          },
          children: t("help.buttonText")
        }
      );
    case "BR":
    default:
      return /* @__PURE__ */ jsx(
        ZendeskButton,
        {
          render: (props) => /* @__PURE__ */ jsx(header_button_default, { leftIcon: /* @__PURE__ */ jsx(HelpHeadsetIcon, {}), ...props, children: t("help.buttonText") })
        }
      );
  }
};
var help_center_header_button_default = HelpCenterHeaderButton;

export {
  help_center_header_button_default
};
